import { attendanceConfig } from "./attendance.config";
import { classSessionConfig } from "./class-session.config";
import { classSessionFeedbackConfig } from "./class-session-feedback.config";
import { coachGoalConfig } from "./coach-goal.config";
import { coachReportConfig } from "./coach-report.config";
import { courseConfig } from "./course.config";
import { dashboardConfig } from "./dashboard.config";
import { deliveryConfig } from "./delivery.config";
import { designTemplateConfig } from "./design-template.config";
import { goalTemplateConfig } from "./goal-template.config";
import { groupConfig } from "./group.config";
import { groupScoreConfig } from "./group-score.config";
import { inClassTaskConfig } from "./in-class-task.config";
import { knowledgeEntryConfig } from "./knowledge-entry.config";
import { knowledgeTagConfig } from "./knowledge-tag.config";
import { mediaConfig } from "./media.config";
import { messageConfig } from "./message.config";
import { orderConfig } from "./order.config";
import { orderAttributionConfig } from "./order-attribution.config";
import { praiseConfig } from "./praise.config";
import { responseExclusionConfig } from "./response-exclusion.config";
import { reviewCourseConfig } from "./review-course.config";
import { salaryConfig } from "./salary.config";
import { staffConfig } from "./staff.config";
import { studentConfig } from "./student.config";
import { studentTopicConfig } from "./student-topic.config";
import { systemIntegrationConfig } from "./system-integration.config";
import { userConfig } from "./user.config";
import { workCalendarConfig } from "./work-calendar.config";
import { workbenchSiteConfig } from "./workbench-site.config";

export const PERMISSIONS_CONFIG = {
  attendance: attendanceConfig,
  student: studentConfig,
  "class-session": classSessionConfig,
  "class-session-feedback": classSessionFeedbackConfig,
  "coach-goal": coachGoalConfig,
  "coach-report": coachReportConfig,
  course: courseConfig,
  "goal-template": goalTemplateConfig,
  group: groupConfig,
  "group-score": groupScoreConfig,
  "in-class-task": inClassTaskConfig,
  "knowledge-entry": knowledgeEntryConfig,
  "knowledge-tag": knowledgeTagConfig,
  media: mediaConfig,
  delivery: deliveryConfig,
  staff: staffConfig,
  user: userConfig,
  message: messageConfig,
  order: orderConfig,
  "order-attribution": orderAttributionConfig,
  dashboard: dashboardConfig,
  "review-course": reviewCourseConfig,
  "workbench-site": workbenchSiteConfig,
  praise: praiseConfig,
  "response-exclusion": responseExclusionConfig,
  "design-template": designTemplateConfig,
  "student-topic": studentTopicConfig,
  "system-integration": systemIntegrationConfig,
  "work-calendar": workCalendarConfig,
  salary: salaryConfig,
} as const;

type InvalidNavigationResource = {
  [Resource in keyof typeof PERMISSIONS_CONFIG]: (typeof PERMISSIONS_CONFIG)[Resource] extends {
    readonly navigation: infer Navigation;
  }
    ? Navigation extends {
        readonly requiredPermissions: readonly (infer LocalKey)[];
      }
      ? Exclude<LocalKey, keyof (typeof PERMISSIONS_CONFIG)[Resource]["permissions"]> extends never
        ? never
        : Resource
      : never
    : never;
}[keyof typeof PERMISSIONS_CONFIG];

type AssertNever<Value extends never> = Value;

/** Compile-time proof that navigation keys belong to their own resource. */
export type NavigationPermissionKeysAreValid = AssertNever<InvalidNavigationResource>;
